// utils/exportMaterialTableCsv.js

function escapeCsv(value) {
  if (value === null || value === undefined) return '';

  const raw = String(value);        // <-- keep original (no trim)
  const trimmed = raw.trim();       // <-- only for checking patterns

  // Excel-defense: stop auto date conversion for numeric ranges like "10-10" / "10 - 10"
  const looksLikeNumericRange = /^\d{1,6}\s*-\s*\d{1,6}$/.test(trimmed);

  // Build output text (preserve the tab!)
  let text = looksLikeNumericRange ? `\t${trimmed}` : raw;

  // Proper CSV escaping
  if (/[",\n]/.test(text)) {
    return `"${text.replace(/"/g, '""')}"`;
  }

  return text;
}





function formatCellValue(row, col) {
  let value = row[col.field];

  // Lookups: export the human label rather than the raw key
  if (col.lookup && value !== null && value !== undefined) {
    value = col.lookup[value] ?? value;
  }

  // Dates: standardize to locale date string (matches what users expect)
  if (col.type === 'date' && value) {
    const d = new Date(value);
    if (!Number.isNaN(d.getTime())) {
      value = d.toLocaleDateString();
    }
  }

  return value ?? '';
}

function getVisibleExportableColumns(columns = []) {
  return columns
    .filter((c) => !c.hidden)
    .filter((c) => Boolean(c.field))      // skip action/detail-only columns
    .filter((c) => c.export !== false);   // allow column opt-out
}

function getAllFilteredRows(dataManager) {
  // Priority order: sorted > filtered > searched > raw
  // We want “what the user is looking at”, but NOT paginated.
  if (Array.isArray(dataManager.sortedData) && dataManager.sortedData.length) {
    return dataManager.sortedData;
  }
  if (Array.isArray(dataManager.filteredData) && dataManager.filteredData.length) {
    return dataManager.filteredData;
  }
  if (Array.isArray(dataManager.searchedData) && dataManager.searchedData.length) {
    return dataManager.searchedData;
  }
  return Array.isArray(dataManager.data) ? dataManager.data : [];
}

function getTitleText(title) {
  if (typeof title === 'string' || typeof title === 'number') return String(title);
  if (Array.isArray(title)) return title.map(getTitleText).join('');
  if (title && title.props) return getTitleText(title.props.children);
  return '';
}

function getColumnHeader(column) {
  return getTitleText(column.title) || column.field || '';
}

function buildCsvString(columns, rows) {
  const headerLine = columns.map((column) => escapeCsv(getColumnHeader(column))).join(',');

  const lines = rows.map((row) => {
    const cells = columns.map((col) => escapeCsv(formatCellValue(row, col)));
    return cells.join(',');
  });

  return [headerLine, ...lines].join('\n');
}

function downloadCsv(filename, csvString) {
  const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });

  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.setAttribute('download', `${filename}.csv`);

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export default function ExportMaterialTable({ tableRef, filename = 'export' }) {
  const tableInstance = tableRef?.current;
  const dataManager = tableInstance?.dataManager;

  if (!dataManager) {
    // material-table not mounted yet, or ref not connected
    return;
  }

  const columns = getVisibleExportableColumns(dataManager.columns);
  const rows = getAllFilteredRows(dataManager);

  const csvString = buildCsvString(columns, rows);
  downloadCsv(filename, csvString);
}
